/** Where this tab keeps the session name it reports onboarding progress under. */
export const ONBOARDING_SESSION_KEY = 'zh.onboarding.session'

type SessionStore = Pick<Storage, 'getItem' | 'setItem'>

/** The tab's own storage, or null where there is none (a private window that refuses it). */
function tabStorage(): SessionStore | null {
    try {
        return globalThis.sessionStorage ?? null
    } catch {
        return null
    }
}

function freshId(): string {
    const id = globalThis.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`
    return `tab-${id}`
}

/**
 * The session (#1737's "tab or conversation") this browser tab reports onboarding progress under: one name per tab,
 * kept for as long as the tab is open, so the server can tell a reload from somebody coming back in a new tab.
 */
export function onboardingSession(storage: SessionStore | null = tabStorage()): string {
    try {
        const kept = storage?.getItem(ONBOARDING_SESSION_KEY)
        if (kept) {
            return kept
        }
        const fresh = freshId()
        storage?.setItem(ONBOARDING_SESSION_KEY, fresh)
        return fresh
    } catch {
        return freshId()
    }
}
